// components/layout/PublicLayout.tsx
/**
 * Layout wrapper for public (tenant-facing) pages
 * Mobile-first design with max-width constraint
 * Design System: Warm Sophistication - warm off-white background
 */
import { type ReactNode } from 'react';

interface PublicLayoutProps {
  children: ReactNode;
  showFooterPadding?: boolean;
}

export function PublicLayout({ children, showFooterPadding = true }: PublicLayoutProps) {
  return (
    <div className="page-public min-h-screen">
      <div
        className={`min-h-screen bg-surface max-w-[430px] mx-auto shadow-lg relative ${
          showFooterPadding ? 'pb-32' : ''
        }`}
      >
        {children}
      </div>
    </div>
  );
}
